/**
 * Samsung 단일 테넌트는 DM (`mode.message`) 을 사용하지 않으므로 본 훅은
 * no-op. Sidebar 가 호출 자체는 유지하므로 시그니처만 보존한다.
 */
export interface UseDMUnreadPollingOptions {
  readonly messageModeEnabled: boolean;
  readonly hasSessionContext: boolean;
  readonly dmWsConnected: boolean;
  readonly nonCriticalReady: boolean;
}

export function useDMUnreadPolling(_options: UseDMUnreadPollingOptions): void {
  // no-op (DM mode is disabled in this build).
}
